export interface IDashSurgicalHistory {
    
}